import * as React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { ApplicationState } from "stores";
import { setLanguage } from "stores/i18n";
import { NavLink } from "react-router-dom";
import { HooplaUser, NavigationLink } from "types";
import User from "components/User";
import Tabs from "components/Tabs";
import Menu from "components/Menu";
import { Language } from "../../stores/i18n";
import * as styles from "./styles";
import logout from "../../helpers/logout";
import { colors } from "styles/styles";
import { GlobeIcon } from "assets/icons/globe";
import { TicketWhiteIcon } from "assets/icons/ticket-white";

interface IProps {
  user?: HooplaUser;
  locale: string;
  setLanguage: (language: Language) => void;
}

export const links: NavigationLink[] = [
  {
    to: "/",
    text: <FormattedMessage id="navigation.tickets" />,
    position: "left",
    exactMatch: true,
  },
  {
    to: "/privacy",
    text: <FormattedMessage id="navigation.consents" />,
    position: "left",
  },
  // { // Hide this tab until the receipts feature is complete
  //   to: '/receipts',
  //   text: <FormattedMessage id="navigation.purchases" />,
  //   position: 'left',
  // },
  {
    to: "/settings",
    text: <FormattedMessage id="navigation.settings" />,
    position: "right",
  },
];

const Header: React.FunctionComponent<IProps & RouteComponentProps<any>> = ({
  user,
  locale,
  setLanguage,
}) => (
  <React.Fragment>
    <div className={styles.topbar}>
      <div className={styles.logoWrapper}>
        <NavLink to="/" style={{ display: "inline-flex" }}>
          <img className={styles.logo} src={require("assets/logo-black-new.svg")} alt="Logo" />
        </NavLink>
      </div>
      <div className={styles.link} onClick={() => setLanguage(locale === "en" ? "nb" : "en")}>
        <GlobeIcon color={colors['grey_20']} size={18} />
        <div style={{ marginLeft: "0.5rem" }}>{locale === "en" ? "Norsk" : "English"}</div>
      </div>
      {user && (
        <div className={styles.link} onClick={logout}>
          <TicketWhiteIcon color={colors['grey_20']} size={18} />
          <div style={{ marginLeft: "0.5rem" }}>
            <FormattedMessage id="components.Header.logout" />
          </div>
        </div>
      )}
      <Menu links={links} />
    </div>
    <div className={styles.container}>
      {user && (
        <React.Fragment>
          <User email={user.email} firstName={user.firstName} lastName={user.lastName} />
          <Tabs links={links} />
        </React.Fragment>
      )}
    </div>
  </React.Fragment>
);

export default withRouter(
  connect(
    (state: ApplicationState) => ({
      locale: state.i18n.locale,
    }),
    { setLanguage },
  )(Header),
);
